import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function CatgoryRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.category.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.sports.category.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.sports.category.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.sports.category.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.sports.category.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.sports.category.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
